import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Services from './components/Services';
import Features from './components/Features';
import CTASection from './components/CTASection';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/c3a968a29d4082d6d920d8d5e4ef7814/71dae59538944291152c6e4daa452af2.png"
              alt="Marquetería y Vidriería Hollywood"
              className="h-12 w-auto object-contain"
            />
            <span className={`text-lg font-semibold ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              Hollywood
            </span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a
              href="#inicio"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#D4856C]' : 'text-white hover:text-[#D4856C]'
              }`}
            >
              Inicio
            </a>
            <a
              href="#cuadros"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#D4856C]' : 'text-white hover:text-[#D4856C]'
              }`}
            >
              Cuadros y Marquetería
            </a>
            <a
              href="#pinturas"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#D4856C]' : 'text-white hover:text-[#D4856C]'
              }`}
            >
              Pinturas al Óleo
            </a>
            <a
              href="#cursos"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#D4856C]' : 'text-white hover:text-[#D4856C]'
              }`}
            >
              Cursos de Pintura
            </a>
            <a
              href="#vidrieria"
              className={`text-sm font-medium transition-colors cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-[#D4856C]' : 'text-white hover:text-[#D4856C]'
              }`}
            >
              Vidriería y Espejos
            </a>
            <a
              href="#contacto"
              className="bg-[#D4856C] text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-[#C07560] transition-colors cursor-pointer whitespace-nowrap"
            >
              Contactar
            </a>
          </div>
        </div>
      </nav>

      <Hero />
      <Introduction />
      <Services />
      <Features />
      <CTASection />
      <Testimonials />
      <Footer />
    </div>
  );
}
